// src/features/account/components/ProfileTopCard.jsx
import React from "react";
import ProfileStatsStrip from "./ProfileStatsStrip";

export default function ProfileTopCard({ header, stats, onChangeTab, activeTab = "pets", loading = false }) {
    const statsSidebar = (
        <ProfileStatsStrip
            stats={stats}
            active={activeTab}
            onOpen={onChangeTab}
            layout="inline"
            loading={loading}
        />
    );

    const headerNode = React.isValidElement(header)
        ? React.cloneElement(header, { sidePanel: statsSidebar })
        : header;

    return (
        <div className="w-full">
            {headerNode}
        </div>
    );
}